import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { FILE_IMPORT_HEADER_CONFIRMATION_STEP, FILE_IMPORT_INITIAL_STEP, FILE_MATCH_FIELDS_STEP } from "../../../constants";
import useFileImportStore from "../../../stores/fileImportStore";

export default function useImportManager() {
  const parsingDone = useFileImportStore((s) => s.parsingDone);
  const currentStep = useFileImportStore((s) => s.currentStep);
  const headerValidation = useFileImportStore((s) => s.headerValidation);
  const currency = useFileImportStore((s) => s.currency);
  const navigate = useNavigate();

  useEffect(() => {
    if (parsingDone && currentStep === FILE_IMPORT_INITIAL_STEP) {
      useFileImportStore.getState().setCurrentStep(FILE_IMPORT_HEADER_CONFIRMATION_STEP);
    }
  }, [parsingDone, currentStep]);

  useEffect(() => {
    if (currentStep === FILE_IMPORT_HEADER_CONFIRMATION_STEP) {
      useFileImportStore.getState().setShowHeaderConfirmationModal(true);
    }
  }, [currentStep]);

  useEffect(() => {
    if (headerValidation && headerValidation.done && headerValidation.isValid) {
      useFileImportStore.getState().setShowChooseCurrencyModal(true);
    }
  }, [headerValidation]);

  useEffect(() => {
    if (currency && currentStep === FILE_IMPORT_HEADER_CONFIRMATION_STEP) {
      useFileImportStore.getState().setCurrentStep(FILE_MATCH_FIELDS_STEP);
    }
  }, [currency, currentStep]);

  useEffect(() => {
    if (currentStep === FILE_MATCH_FIELDS_STEP) {
      navigate("/dashboard/import-bom-csv/match-csv-fields/", { replace: true });
    }
  }, [currentStep, navigate]);
}
